import React from 'react'
import * as Icon from 'react-feather';
export default function Boxes() {
  return (
   
    <section className="boxes-area">
                <div className="container">
                    <div className="row">
                         <div className="col-lg-6 col-md-6">
                <div className="single-box"  >
                    <div className="icon"> <Icon.Command />
                       
                    </div>
                    <h3>Uncompromising Quality</h3>
                    <p>Since our inception in 2006, we have transformed from a weaving division into a comprehensive manufacturing. Our in-house inspection team employs the 4-point system to examine every meter of fabric, ensuring that our products meet the highest industry standards.</p>
                </div>
            </div>
    
            <div className="col-lg-6 col-md-6">
                <div className="single-box bg-f78acb" >
                    <div className="icon">
                    <Icon.TrendingUp />
                    </div>
                    <h3>Ethical Business Practices</h3>
                    <p>We believe in conducting our business with integrity and transparency at every level. Our commitment to ethical practices ensures that we prioritize fair treatment of our employees and responsible sourcing of materials, fostering trust with our partners and customers.</p>
                </div>
            </div>
    
            <div className="col-lg-6 col-md-6 pt-1">
                <div className="single-box bg-c679e3">
                    <div className="icon">
                    <Icon.Truck />
                    </div>
                    <h3>Timely Delivery Commitment</h3>
                    <p>In response to the evolving demands of the market, we have continuously refined our production processes to enhance efficiency. Our unwavering focus on timely delivery ensures that we meet our customers' changing needs while upholding our reputation as a reliable partner in the home textiles industry.</p>
                </div>
            </div>
            
            <div className="col-lg-6 col-md-6 pt-1">
                <div className="single-box bg-eb6b3d">
                    <div className="icon">
                    <Icon.Shield />
                    </div>
                    <h3>Sustainability & Trust</h3>
                    <p>Sustainability is woven into the fabric of our operations, guiding us to adopt environmentally responsible practices throughout our production process. We continuously assess our impact and strive to minimize our ecological footprint, building trust with our customers through our dedication to the planet.</p>
                </div>
            </div>
        </div>
    </div>
    </section>
  )
}
